// SearchBar.js
import React from 'react';
import { TextField } from '@mui/material';

const SearchBar = ({ searchQuery, setSearchQuery }) => {
    return (
        <TextField
            label="Search Pooja"
            variant="outlined"
            fullWidth
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            sx={{ marginBottom: '20px' }}
        />
    );
};

export default SearchBar;
